<template>
  <div class="main-content">
    <audio ref="audioDing" src="@/assets/sounds/ding_extended_10s.mp3"></audio>
    <audio ref="audioAVC" src="@/assets/sounds/avc_alert_10s.mp3"></audio>
    <div
      class="row justify-content-center align-items-center"
      v-show="chamando"
      style="height: 90vh"
    >
      <div v-if="occurrence_speaking" class="text-center">
        <div
          v-if="
            isAVCOccurrence(occurrence_speaking) &&
            occurrence_speaking.agency &&
            occurrence_speaking.agency.alert
          "
          class="mb-3"
        >
          <h1
            style="
              font-size: 12vh;
              color: #dc3545;
              margin-bottom: 2vh;
              animation: blink 1s infinite;
            "
          >
            🚨 ALERTA AVC - PRIORIDADE CRÍTICA 🚨
          </h1>
        </div>
        <h1 style="font-size: 10vh; color: #333; margin-bottom: 2vh">
          NOVA OCORRÊNCIA A CAMINHO:
        </h1>
        <h2 style="font-size: 5vh; color: #333; margin-bottom: 2vh">
          🚨 Nº DA FICHA -
          {{ occurrence_speaking.external_id }}
          <br />
          UNIDADE: {{ occurrence_speaking.unit.unit_name }}
          <br />
          AGÊNCIA:
          {{
            occurrence_speaking.agency
              ? occurrence_speaking.agency.fantasy_name
              : ""
          }}
          <br />
          <template v-if="occurrence_speaking.central_id == 2">
            <i class="fas fa-ambulance"></i> VEÍCULO:
            {{
              occurrence_speaking.team
                ? occurrence_speaking.team.name
                : occurrence_speaking.vehicle || ""
            }}
            <br />
            HORA CHEGADA PREVISTA: {{ occurrence_speaking.arrival_time || "" }}
          </template>
          <template v-else>
            CLASSIFICAÇÃO: {{ occurrence_speaking.classification_f }}
          </template>
        </h2>
        <button
          class="btn btn-success btn-lg mt-4"
          @click="confirmAlert"
          style="font-size: 3vh; padding: 20px 60px; font-weight: bold"
        >
          ✓ OK - CIENTE
        </button>
      </div>
    </div>

    <div class="row mb-3" v-show="!chamando">
      <div class="form-group ml-2" style="margin-top: -3px; min-width: 200px">
        <label for="flagUnitSelect">Agência:</label>
        <select
          id="flagUnitSelect"
          class="form-control"
          v-model="filters.central_id"
          @change="getOccurrences"
        >
          <option :value="null" selected>Exibir Todos</option>
          <option
            v-for="central in centrals"
            :key="central.id"
            :value="central.id"
          >
            {{ central.fantasy_name }}
          </option>
        </select>
      </div>
      <div class="form-group ml-2" style="margin-top: -3px; min-width: 200px">
        <label for="flagUnitSelect">Serviço:</label>
        <select
          id="flagUnitSelect"
          class="form-control"
          v-model="filters.occurrence_type"
          @change="getOccurrences"
        >
          <!-- <option :value="null">Exibir Ambos</option> -->
          <!-- <option :value="'TIH'">Exibir TIH</option> -->
          <option :value="'APH'">Exibir APH</option>
        </select>
      </div>
      <div class="form-group ml-2" style="margin-top: 25px">
        <button class="btn btn-sm btn-outline-secondary" @click="toggleSound">
          <i :class="muted ? 'fas fa-volume-mute' : 'fas fa-volume-up'"></i>
          {{ muted ? "Som Desligado" : "Som Ligado" }}
        </button>
      </div>
    </div>
    <div class="row" v-show="!chamando">
      <div class="col-12">
        <div class="card p-1">
          <div class="table-responsive">
            <table class="table table-bordered table-hover table-sm">
              <thead>
                <tr>
                  <th style="width: 40px; text-align: center"></th>
                  <th>Nº Ocorrência</th>
                  <th>Serviço</th>
                  <th>Agência</th>
                  <th>Unidade</th>
                  <th>Veículo</th>
                  <th>Data Abertura</th>
                  <th>Saída do Local</th>
                  <th>Data Previsão Chegada</th>
                  <!-- <th>Hora Chegada</th> -->
                  <th>Tipo</th>
                  <th>Motivo</th>
                  <th>Idade</th>
                  <th>Sexo</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="occurrence in occurrences" :key="occurrence.id">
                  <td style="width: 40px; text-align: center">
                    <span :title="occurrence.classification">
                      {{ occurrence.classification_f }}
                    </span>
                  </td>
                  <td>{{ occurrence.external_id }}</td>
                  <td>{{ occurrence.occurrence_type }}</td>
                  <td>
                    {{
                      occurrence.agency ? occurrence.agency.fantasy_name : ""
                    }}
                  </td>
                  <td>
                    {{ occurrence.unit ? occurrence.unit.unit_name : "" }}
                  </td>
                  <td>
                    <template v-if="occurrence.central_id == 7">
                      {{ occurrence.team ? occurrence.team.name : "" }}
                    </template>
                    <template v-else>
                      {{ occurrence.vehicle }}
                    </template>
                  </td>
                  <td>{{ occurrence.opening_date_h }}</td>
                  <td>{{ occurrence.departure_from_unit_f }}</td>
                  <td>
                    <template v-if="occurrence.central_id == 7">
                      {{ occurrence.arrival_time }}
                    </template>
                    <template v-else>
                      {{
                        occurrence.estimated_arrival
                          ? occurrence.estimated_arrival_f
                          : "Não informado"
                      }}
                    </template>
                  </td>
                  <!-- <td>{{ occurrence.arrival_time }}</td> -->
                  <td>{{ occurrence.type ? occurrence.type.title : "" }}</td>
                  <td>
                    {{ occurrence.reason ? occurrence.reason.title : "" }}
                  </td>

                  <td>{{ occurrence.people ? occurrence.people.age : "" }}</td>
                  <td>
                    {{ occurrence.people ? occurrence.people.gender : "" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2" v-show="!chamando">
      <div class="col-12">
        <div class="card p-2">
          <div
            class="d-flex justify-content-around align-items-center flex-wrap mt-1"
          >
            <strong>Legenda Classificação de Risco:</strong>
            <div class="d-flex align-items-center mx-3">
              <span class="dot bg-primary"></span>
              <span class="ml-1 h6 mb-0"><strong>Não urgente</strong></span>
            </div>
            <div class="d-flex align-items-center mx-3">
              <span class="dot" style="background-color: #28a745"></span>
              <span class="ml-1 h6 mb-0"><strong>Pouco urgente</strong></span>
            </div>
            <div class="d-flex align-items-center mx-3">
              <span class="dot" style="background-color: #ffff00"></span>
              <span class="ml-1 h6 mb-0"><strong>Urgente</strong></span>
            </div>
            <div class="d-flex align-items-center mx-3">
              <span class="dot" style="background-color: #fd7e14"></span>
              <span class="ml-1 h6 mb-0"><strong>Muito urgente</strong></span>
            </div>
            <div class="d-flex align-items-center mx-3">
              <span class="dot bg-danger"></span>
              <span class="ml-1 h6 mb-0"><strong>Emergência</strong></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "vue-pagination-2";
import dingSound from "@/assets/sounds/ding_extended_10s.mp3";

export default {
  data() {
    return {
      occurrence_speaking: null,
      chamando: 0,
      speaking: 0,
      vozCarregada: false,
      filters: {
        central_id: null,
        occurrence_type: "APH",
      },
      occurrences: [],
      selectedOccurrenceId: null,
      muted: false,
      centrals: [],
      audioInterval: null,
    };
  },
  components: {
    Pagination,
  },
  watch: {
    selectedOccurrenceId: {
      handler(val) {
        if (val) {
          console.log("entrou", val);
          window.Echo.private("new_status." + val).listen(".Status", (e) => {
            console.log("ewerwerwerwe", val);
            const index = this.occurrences.findIndex(
              (o) => o.external_id === e.occurrence.external_id
            );
            console.log("entrou2", val);
            this.occurrences[index].status = e.occurrence.status;
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    getOccurrences() {
      const api = this.$store.state.api + "video_wall";
      this.$loading(true);
      axios
        .post(api, this.filters)
        .then((response) => {
          this.occurrences = response.data;
          this.showPendingAlert();
          this.$loading(false);
        })
        .catch((error) => {
          this.$message(null, error.response.data, "error");
          this.$loading(false);
        });
    },

    showPendingAlert() {
      // Sempre exibe o alerta para a primeira OC com alert_clicked = false
      const nextAlert = this.occurrences.find(
        (o) => o.alert_clicked === false || o.alert_clicked === 0
      );
      if (nextAlert) {
        this.chamarOcorrencia(nextAlert);
      } else {
        this.chamando = 0;
        this.occurrence_speaking = null;
      }
    },
    playSound(volume = 1) {
      if (this.muted) return;

      const audio = new Audio(dingSound);
      audio.volume = volume;
      audio.play().catch(() => {});
    },
    async waitUntilTrue(e) {
      while (this.chamando == 1) {
        await new Promise((resolve) => setTimeout(resolve, 100));
        console.log("esperando");
      }
      this.chamarOcorrencia(e);
    },

    normalizeAgencyName(name) {
      if (/^[A-ZÇÁÉÍÓÚÂÊÔÃÕÜ]{2,}$/.test(name)) {
        return name.charAt(0) + name.slice(1).toLowerCase();
      }
      return name;
    },

    isAVCOccurrence(occurrence) {
      if (!occurrence) return false;

      const searchTerm = "AVC";

      // Verificar no tipo
      if (
        occurrence.type?.title &&
        occurrence.type.title.toUpperCase().includes(searchTerm)
      ) {
        return true;
      }

      // Verificar no motivo
      if (
        occurrence.reason?.title &&
        occurrence.reason.title.toUpperCase().includes(searchTerm)
      ) {
        return true;
      }

      // Verificar na descrição
      if (
        occurrence.description &&
        occurrence.description.toUpperCase().includes(searchTerm)
      ) {
        return true;
      }

      // Verificar na queixa
      if (
        occurrence.complaint &&
        occurrence.complaint.toUpperCase().includes(searchTerm)
      ) {
        return true;
      }

      return false;
    },

    chamarOcorrencia: function (e) {
      const self = this;
      self.chamando = 1;
      self.occurrence_speaking = e;

      // Função para tentar tocar o áudio quando o ref existir
      function tryPlayAudio(tentativas = 0) {
        if (self.muted) return;
        const isAVC = self.isAVCOccurrence(e);
        const hasAgencyAlert = e.agency && e.agency.alert;
        const shouldUseAVCAlert = isAVC && hasAgencyAlert;
        const audio = shouldUseAVCAlert
          ? self.$refs.audioAVC
          : self.$refs.audioDing;
        if (audio) {
          audio.play().catch(() => {});
          self.audioInterval = setInterval(() => {
            if (self.chamando && !self.muted) {
              audio.currentTime = 0;
              audio.play().catch(() => {});
            }
          }, 10000);
        } else if (tentativas < 10) {
          setTimeout(() => tryPlayAudio(tentativas + 1), 150);
        }
      }
      tryPlayAudio();

      // let estimatedArrival = e.arrival_time;
      // if (estimatedArrival.includes("mins")) {
      //   estimatedArrival = estimatedArrival.replace("mins", "minutos");
      // }

      // const agencyNameForSpeech = this.normalizeAgencyName(
      //   e.agency.fantasy_name
      // );

      // window.responsiveVoice.speak(
      //   "Nova Ocorrência a caminho, via " +
      //     agencyNameForSpeech +
      //     ", chega em " +
      //     estimatedArrival,
      //   "Brazilian Portuguese Female",
      //   {
      //     onstart: () => {
      //       console.log("🔊 Fala iniciada");
      //       self.speaking = true;
      //       self.chamando = 1;
      //     },
      //     onend: () => {
      //       console.log("✅ Fala finalizada");
      //       setTimeout(() => {
      //         self.speaking = false;
      //         self.chamando = 0;
      //         self.occurrence_speaking = null;
      //       }, 2000);
      //     },
      //     onerror: (e) => {
      //       console.error("❌ Erro ao falar:", e);
      //       self.speaking = false;
      //       self.chamando = 0;
      //       self.occurrence_speaking = null;
      //     },
      //   }
      // );
    },
    loadVoice() {
      const script = document.createElement("script");
      script.src =
        "https://code.responsivevoice.org/responsivevoice.js?key=HOp1bC0P";
      script.async = true;

      script.onload = () => {
        this.vozCarregada = true;
      };
      script.onerror = () => {
        console.error("Erro ao carregar o script responsiveVoice.");
      };
      document.head.appendChild(script);
    },

    toggleSound() {
      this.muted = !this.muted;

      console.log(this.muted);

      // window.responsiveVoice.speak(
      //   this.muted == false ? "Cisbaf" : "Som desativado",
      //   "Brazilian Portuguese Female",
      //   {
      //     onstart: () => {
      //       console.log("🔊 Fala iniciada");
      //       this.speaking = true;
      //       self.chamando = 1;
      //     },
      //     onend: () => {
      //       console.log("✅ Fala finalizada");
      //       this.speaking = false;
      //       self.chamando = 0;
      //     },
      //     onerror: (e) => {
      //       console.error("❌ Erro ao falar:", e);
      //       this.speaking = false;
      //       self.chamando = 0;
      //     },
      //   }
      // );
    },
    getCentrals: function () {
      const self = this;
      const api = self.$store.state.api + "centrals?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.centrals = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    confirmAlert: function () {
      const self = this;

      // Para o áudio imediatamente
      if (self.audioInterval) {
        clearInterval(self.audioInterval);
        self.audioInterval = null;
      }
      const audio = self.$refs.audioDing;
      audio.pause();
      audio.currentTime = 0;

      // Registra a confirmação na API
      const api = self.$store.state.api + "occurrences/acknowledge";
      axios
        .post(api, {
          occurrence_id: self.occurrence_speaking.id,
        })
        .then((response) => {
          self.chamando = 0;
          self.occurrence_speaking = null;
        })
        .catch((error) => {
          self.chamando = 0;
          self.occurrence_speaking = null;
        });
    },
  },
  mounted() {
    const self = this;
    this.getOccurrences();
    this.getCentrals();

    setTimeout(() => {
      Echo.private("new_status." + 1).listen(".Status", (e) => {
        self.getOccurrences();
      });
    }, 2000);

    setTimeout(() => {
      const userId = this.$store.state.user.usuario_id;
      if (userId) {
        window.Echo.private(`private-user.${userId}`).listen(
          ".NewOccurrence",
          (e) => {
            if (
              !this.filters.central_id ||
              e.occurrence.central_id == this.filters.central_id
            ) {
              this.occurrences.unshift(e.occurrence);
              this.showPendingAlert();
            }
          }
        );
      }
    }, 3000);
  },
  beforeDestroy() {
    // Para o áudio e limpa o intervalo ao sair da tela
    if (this.audioInterval) {
      clearInterval(this.audioInterval);
      this.audioInterval = null;
    }
    if (this.$refs.audioDing) {
      this.$refs.audioDing.pause();
      this.$refs.audioDing.currentTime = 0;
    }
    if (this.$refs.audioAVC) {
      this.$refs.audioAVC.pause();
      this.$refs.audioAVC.currentTime = 0;
    }
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.main-content {
  padding: 20px;
}

.table th,
.table td {
  text-align: center;
}

.btn {
  background-color: #eee;
  border: 1px solid #ccc;
  padding: 5px 10px;
  margin-right: 5px;
  cursor: pointer;
}
.btn.active {
  background-color: #15488a;
  color: white;
}
.dot {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 4px;
}

@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}
</style>
